export const ESCALATION_FIELDS_CONFIG = {
  // ============================================
  // TICKET FIELDS
  // ============================================
  ticket_fields: {
    group_name: "Ticket Fields",
    display_order: 1,
    fields: [
      {
        field_code: "assigned_to_admin_group",
        field_name: "Admin Group",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/employee/v1/getGroupByType/admin",
        available_in_conditions: true,
        available_in_actions: true,
        operators: ["equals", "not_equals", "is_null", "is_not_null", "in", "not_in"]
      },
      {
        field_code: "assigned_to",
        field_name: "Assigned To",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/employee/v1/getEmpByGroup/24",
        label_key: "employeeName",
        value_key: "employeeId",
        available_in_conditions: true,
        available_in_actions: true,
        operators: ["equals", "not_equals", "is_null", "is_not_null", "in", "not_in"]
      },
      {
        field_code: "status",
        field_name: "Status",
        field_type: "select",
        data_source: "api",
        api_endpoint: "tickets/ticket/statuses",
        available_in_conditions: true,
        available_in_actions: true,
        operators: ["equals", "not_equals", "in", "not_in"]
      },
      {
        field_code: "priority",
        field_name: "Priority",
        field_type: "select",
        data_source: "static",
        static_options: [
          { value: "low", label: "Low" },
          { value: "medium", label: "Medium" },
          { value: "high", label: "High" },
          { value: "urgent", label: "Urgent" }
        ],
        available_in_conditions: true,
        available_in_actions: true,
        operators: ["equals", "not_equals", "in", "not_in"]
      },
      {
        field_code: "category_config_id",
        field_name: "Category",
        field_type: "select",
        data_source: "api",
        api_endpoint: "tickets/categories/list",
        available_in_conditions: true,
        available_in_actions: true,
        operators: ["equals", "not_equals", "in", "not_in"]
      },
      {
        field_code: "requested_for",
        field_name: "Requested For",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/employee/v1/getAllActiveEmp",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "not_equals", "in", "not_in"]
      },
      {
        field_code: "created_by",
        field_name: "Created By",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/employee/v1/getAllActiveEmp",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "not_equals", "in", "not_in"]
      },
      {
        field_code: "ticket_number",
        field_name: "Ticket Number",
        field_type: "text",
        data_source: "static",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "not_equals", "contains", "starts_with", "ends_with"]
      },
      {
        field_code: "title",
        field_name: "Ticket Title",
        field_type: "text",
        data_source: "static",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "contains", "not_contains", "starts_with", "ends_with"]
      },
      {
        field_code: "description",
        field_name: "Description",
        field_type: "text",
        data_source: "static",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["contains", "not_contains"]
      },
      {
        field_code: "is_reopened",
        field_name: "Is Reopened",
        field_type: "boolean",
        data_source: "static",
        static_options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" }
        ],
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals"]
      },
      {
        field_code: "created_on",
        field_name: "Created Date",
        field_type: "datetime",
        data_source: "static",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal"]
      },
      {
        field_code: "updated_on",
        field_name: "Updated Date",
        field_type: "datetime",
        data_source: "static",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal"]
      },
      {
        field_code: "closed_at",
        field_name: "Closed Date",
        field_type: "datetime",
        data_source: "static",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["is_null", "is_not_null", "greater_than", "less_than"]
      },
      {
        field_code: "end_user_notification",
        field_name: "End User Notification",
        field_type: "select",
        data_source: "static",
        static_options: [
          { value: "first_notification_sent", label: "First Notification Sent" },
          { value: "second_notification_sent", label: "Second Notification Sent" },
          { value: "ticket_closed", label: "Ticket Closed" }          
        ],
        available_in_conditions: true,
        available_in_actions: true,
        operators: ["is_null", "is_not_null", "equals", "not_equals"]
      }, 
      {
        field_code: "solution_text",
        field_name: "Solution",
        field_type: "text",
        data_source: "static",
        available_in_conditions: false,
        available_in_actions: true,
        operators: ["contains", "not_contains"]
      }      
    ]
  },

  

  // ============================================
  // LOCATION FIELDS
  // ============================================
  location_fields: {
    group_name: "Location Fields",
    display_order: 2,
    fields: [
      {
        field_code: "store_id",
        field_name: "Store (SAP)",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/store",
        available_in_conditions: true,
        available_in_actions: false,
        label_key: "store_name",
        value_key: "id",
        operators: ["equals", "not_equals", "is_null", "is_not_null", "in", "not_in"]
      },
      {
        field_code: "market_id",
        field_name: "Market (District)",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/market",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "not_equals", "is_null", "is_not_null", "in", "not_in"]
      },
      {
        field_code: "region_id",
        field_name: "Region",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/region",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "not_equals", "is_null", "is_not_null", "in", "not_in"]
      },
      {
        field_code: "division_id",
        field_name: "Division",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/division",
        available_in_conditions: true,
        available_in_actions: true,
        operators: ["equals", "not_equals", "is_null", "is_not_null", "in", "not_in"]
      },
      {
        field_code: "company_id",
        field_name: "Company",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/company",
        label_key: "company_name",
        value_key: "id",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "not_equals", "is_null", "is_not_null", "in", "not_in"]
      }
    ]
  },

  // ============================================
  // JOB FIELDS
  // ============================================
  job_fields: {
    group_name: "Job Fields",
    display_order: 3,
    fields: [
      {
        field_code: "job_title_id",
        field_name: "Job Title",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/employee/v1/jobtitle",
        label_key: "job_title",
        value_key: "id",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "not_equals", "is_null", "is_not_null", "in", "not_in"]
      },
      {
        field_code: "department_id",
        field_name: "Department",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/employee/v1/department",
        label_key: "department_name",
        value_key: "id",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "not_equals", "in", "not_in"]
      }
    ]
  },
  
    // ============================================
  // CATEGORY FIELDS
  // ============================================
  category_fields: {
    group_name: "Category Fields",
    display_order: 3,
    fields: [
      {
        field_code: "category_company_id",
        field_name: "Company",
        field_type: "select",
        data_source: "api",
        api_endpoint: "/company",
        label_key: "company_name",
        value_key: "id",
        available_in_conditions: true,
        available_in_actions: false,
        operators: ["equals", "not_equals", "is_null", "is_not_null", "in", "not_in"]
      }
    ]
  },
};



export const EscalationListSummaryConstants = {
  BaseSummary: "Escalates service records with",
  NoConditions: "no conditions",
  TicketCreation: "Triggers after ticket creation",
  TicketUpdate: "Triggers after ticket update",
  Scheduled: "Triggers on",
  SetTheFollowingFields: "Set the following fields",
  Notifies: "Notifies",
  EndUserNotificationSentTo: "End User Notification Sent To",
  
  
};